import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'src/redux/store';
import axios from 'src/utils/axios';

const initialState = {
    isBlogCategoryLoading: false,
    error: null,
    blog_categories: null,
};

const slice = createSlice({
    name: 'blog',
    initialState,
    reducers: {
        // START LOADING
        startBlogCategoryLoading(state) {
            state.isBlogCategoryLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isBlogCategoryLoading = false;
            state.isPlanLoading = false;
            state.error = action.payload;
        },
        // SET DATA
        setBlogCategory(state, action) {
            state.isBlogCategoryLoading = false;
            state.blog_categories = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startBlogCategoryLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getBlogCategories() {
    return async () => {
        dispatch(slice.actions.startBlogCategoryLoading());
        try {
            const response = await axios.get(`/dropdown/catalog/blog_categories`);
            dispatch(slice.actions.setBlogCategory(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}